import React, { useContext, useEffect, useState } from 'react';
import ImageComponent from '../../helpers/ImageComponent';
import SignOutButton from './SignOutButton';
//css
import './Header.css';
//assets
import logo from '../../assets/logo.png';
import { UserContext } from '../../contexts/UserContext';

export default function Header() {
  const {loggedInUserData} = useContext(UserContext);
  const [loggedInUserInitials, setLoggedInUserInitials] = useState("");

  useEffect(() => {
    if (loggedInUserData) {
      const userName = loggedInUserData.name?.split(" ");
      const firstName = userName[0] || "";
      const lastName = userName[1] || "";
      setLoggedInUserInitials(`${firstName.charAt(0)}${lastName.charAt(0)}`);
    }
  }, [loggedInUserData]);

  return (
    <div className='header-container'>
      <div className='header-content'>
        <div className='left-header'>
          <ImageComponent sourceUrl={logo} details="WPSLogo" />
        </div>
        <div className='center-header'>
          <h3>Global Tradeshow Solution</h3>
        </div>
        <div className='right-header'>
          <div className='userNameCircle'>
            <span className='userNameInitials'>{loggedInUserInitials}</span>
          </div>
          <SignOutButton />
        </div>
      </div>
    </div>
  );
}
